export default {"src":"/_next/static/media/iconRemove.1ad76f55.svg","height":28,"width":28};